module.exports = __webpack_public_path__ + "img/ccdsinfotop.2406671c.png";